import Cookies from 'js-cookie'

const state = {
  sidebar: {
    opened: Cookies.get('sidebarStatus') ? !!+Cookies.get('sidebarStatus') : true,
    withoutAnimation: false,
  },
  device: 'desktop',
  size: Cookies.get('size') || 'medium',
  messageCount: 0,
  faultBackCount: 0,
  showElectronicScroll: false,
  showDialog: false,
  showNotify: false,
  showDownloadLoading: false,
  showDownloadLoadingText: '',
  showAIProcessLoading: false,
  showAIProcessLoadingText: '',
}

const mutations = {
  TOGGLE_SIDEBAR: state => {
    state.sidebar.opened = !state.sidebar.opened
    state.sidebar.withoutAnimation = false
    if (state.sidebar.opened) {
      Cookies.set('sidebarStatus', 1)
    } else {
      Cookies.set('sidebarStatus', 0)
    }
  },
  CLOSE_SIDEBAR: (state, withoutAnimation) => {
    Cookies.set('sidebarStatus', 0)
    state.sidebar.opened = false
    state.sidebar.withoutAnimation = withoutAnimation
  },
  TOGGLE_DEVICE: (state, device) => {
    state.device = device
  },
  SET_SIZE: (state, size) => {
    state.size = size
    Cookies.set('size', size)
  },
  SET_MESSAGE: (state, count) => {
    state.messageCount = count
    Cookies.set('messageCount', count)
  },
  SET_FAULTBACK: (state, count) => {
    state.faultBackCount = count
    Cookies.set('faultBackCount', count)
  },
  SHOW_ESCROLL: (state, doing) => {
    state.showElectronicScroll = doing
    Cookies.set('showElectronicScroll', doing)
  },
  SHOW_DIALOG: (state, doing) => {
    state.showDialog = doing
    Cookies.set('showDialog', doing)
  },
  SHOW_NOTIFY: (state, doing) => {
    state.showNotify = doing
    Cookies.set('showNotify', doing)
  },
  SHOW_DOWNLOAD_LOADING: (state, doing) => {
    state.showDownloadLoading = doing
    Cookies.set('showDownloadLoading', doing)
  },
  SHOW_DOWNLOAD_LOADING_TEXT: (state, doing) => {
    state.showDownloadLoadingText = doing
    Cookies.set('showDownloadLoadingText', doing)
  },
  SHOW_AI_PROCESS_LOADING: (state, doing) => {
    state.showAIProcessLoading = doing
    //Cookies.set('showAIProcessLoading', doing)
  },
  SHOW_AI_PROCESS_LOADING_TEXT: (state, doing) => {
    state.showAIProcessLoadingText = doing
    //Cookies.set('showAIProcessLoadingText', doing)
  },
}

const actions = {
  toggleSideBar({ commit }) {
    commit('TOGGLE_SIDEBAR')
  },
  closeSideBar({ commit }, { withoutAnimation }) {
    commit('CLOSE_SIDEBAR', withoutAnimation)
  },
  toggleDevice({ commit }, device) {
    commit('TOGGLE_DEVICE', device)
  },
  setSize({ commit }, size) {
    commit('SET_SIZE', size)
  },
  setMessage({ commit }, count) {
    commit('SET_MESSAGE', count)
  },
  setFaultBackCount({ commit }, count) {
    commit('SET_FAULTBACK', count)
  },
  showEscroll({ commit }, doing) {
    commit('SHOW_ESCROLL', doing)
  },
  showDialog({ commit }, doing) {
    commit('SHOW_DIALOG', doing)
  },
  showNotify({ commit }, doing) {
    commit('SHOW_NOTIFY', doing)
  },
  showDownloadLoading({ commit }, doing) {
    commit('SHOW_DOWNLOAD_LOADING', doing)
  },
  showDownloadLoadingText({ commit }, doing) {
    commit('SHOW_DOWNLOAD_LOADING_TEXT', doing)
  },
  showAIProcessLoading({ commit }, doing) {
    commit('SHOW_AI_PROCESS_LOADING', doing)
  },
  showAIProcessLoadingText({ commit }, doing) {
    commit('SHOW_AI_PROCESS_LOADING_TEXT', doing)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
